<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-lab-sidebar></app-lab-sidebar> -->

      <div class="card shadow m-3" style="width: 100%">
        <div class="card-header heading_n_button_box">
          <div class="card-heading">
            <h4>List of Results</h4>
          </div>

          <div class="button-section mt-1">
            <!-- <div class="dropdown">
                            <button class="mr-4 small-btn-dash dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Enrol Traveller
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="#">Arriving Equitorial Guinea</a>
                                <a class="dropdown-item" href="#">Departing Equitorial Guinea</a>
                            </div>
                        </div> -->
          </div>
        </div>
        <div class="card-body">
          <div class="col-lg-12">
            <div>
              <form
                [formGroup]="searchForm"
                (ngSubmit)="onSubmitSearch(searchForm.value)"
              >
                <div class="row">
                  <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                    <select
                      class="form-select select-option col-lg-12"
                      name="traveller_type"
                      formControlName="traveller_type"
                      id="traveller_type"
                    >
                      <option selected value="">Type of Traveller</option>
                      <option
                        *ngFor="let type of shared.travelTypes"
                        [value]="type.id"
                      >
                        {{ type.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                    <input
                      class="form-control icon-cal font-12"
                      type="text"
                      formControlName="daterangeInput"
                      placeholder="Result: Date From - Date To"
                      daterangepicker
                      [options]="options"
                      (selected)="selectedDate($event, daterange)"
                      title="Result: Date From - Date To"
                    />
                  </div>

                  <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                    <select
                      class="form-select select-option col-lg-12"
                      name="payment_status"
                      formControlName="payment_status"
                      id="payment_status"
                    >
                      <option selected value="">Payment Status</option>
                      <option value="1">Paid</option>
                      <option value="0">Pending</option>
                    </select>
                  </div>

                  <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                    <div class="mr-4">
                      <button
                        class="btn btn-secondary theme-btn-2 dropdown-toggle-no"
                        type="submit"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-search"></i> Search
                      </button>

                      <button
                        class="
                          btn btn-secondary
                          theme-btn-2
                          dropdown-toggle-no
                          ml-2
                        "
                        type="button"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                        (click)="clearSearch()"
                      >
                        <i class="fas fa-sync-alt"></i> Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- <h3 class="dashboard-heading-1">Passenger personal Information</h3> -->
            <div class="">
              <div class="table-responsive mt-3">
                <div class="col-auto">
                  <div class="row" *ngIf="results">
                    <div class="show-record mt-3 mbm-32">
                      <span>Show</span> &nbsp;
                      <select
                        class="
                          custom-select custom-select-sm
                          form-control form-control-sm
                        "
                        (change)="setItemsPerPage(page.value)"
                        #page
                      >
                        <option [selected]="currentPageLength == 10">10</option>
                        <option [selected]="currentPageLength == 30">30</option>
                        <option [selected]="currentPageLength == 50">50</option>
                        <option [selected]="currentPageLength == 100">
                          100
                        </option>
                        <option [selected]="currentPageLength == 500">
                          500
                        </option>
                        <option [selected]="currentPageLength == 1000">
                          1000
                        </option>
                      </select>
                      &nbsp;
                      <span> entries</span>
                    </div>
                  </div>
                </div>

                <table
                  *ngIf="results"
                  class="
                    table
                    table-bordered
                    table-condensed
                    table-responsive-sm
                    table-responsive-md
                    table-responsive-lg
                    table-responsive-xl
                    nowrap
                  "
                  datatable
                  [dtOptions]="dtOptions"
                  width="100%"
                >
                  <thead class="">
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">Appointment ID</th>
                      <th scope="col">Surname</th>
                      <th scope="col">First Name</th>
                      <th scope="col">Passport Number</th>
                      <th scope="col">Type Of Traveller</th>
                      <th scope="col">Phone Number</th>
                      <th scope="col">Sample Collection Date</th>
                      <th scope="col">Sample Collection Center</th>
                      <th scope="col">Date Of Result</th>
                      <th scope="col">Result</th>
                      <th scope="col">Result Validity</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody class="dashboard-bg-white">
                    <tr
                      *ngFor="
                        let result of results | paginate: config;
                        index as i
                      "
                    >
                      <th scope="row">
                        {{
                          config.itemsPerPage * (config.currentPage - 1) + i + 1
                        }}
                      </th>
                      <td>{{ result.appointment_id }}</td>
                      <td>{{ result.last_name }}</td>
                      <td>{{ result.first_name }}</td>
                      <!-- <td>Ojo</td> -->
                      <td>{{ result.passport_no }}</td>
                      <td>
                        <span *ngIf="result.type == '1'"> Departing EG </span>
                        <span *ngIf="result.type == '2'"> Arriving EG </span>
                      </td>
                      <td>{{ result.phone }}</td>
                      <!-- <td>Jun 10, 2021</td> -->
                      <td>
                        {{
                          result.booking_date + " " + result.booking_time
                            | date: "medium"
                        }}
                      </td>
                      <td>{{ result.center_name }}</td>
                      <!-- To be updated when: response data is populated -->
                      <td>{{ result.result_date }}</td>
                      <td>
                        <span
                          *ngIf="result.status == 'NEGATIVE'"
                          class="active-btn"
                          >{{ result.status | titlecase }}</span
                        >
                        <span
                          *ngIf="result.status == 'POSITIVE'"
                          class="inactive-btn"
                          >{{ result.status | titlecase }}</span
                        >
                      </td>
                      <td>
                        <span>{{ result.validity_date }}</span>
                      </td>
                      <td>
                        <button
                          class="btn-view"
                          type="button"
                          (click)="
                            showResultDetails(result, showResultDetailsModal)
                          "
                          title="View result"
                        >
                          <i class="far fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="table-footer">
                  <div
                    id="page_info"
                    class="mt-3 record-show-text-bottom"
                    *ngIf="results"
                  >
                    Showing
                    {{ (config.currentPage - 1) * config.itemsPerPage + 1 }} -
                    {{ config.currentPage * config.itemsPerPage }} of
                    {{ config.totalItems }} entries
                  </div>

                  <div class="pagination paging-pull-right" *ngIf="results">
                    <pagination-controls
                      (pageChange)="pageChange($event)"
                      class="my-pagination mt-2 pagination-server"
                    >
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showResultDetailsModal let-modal>
  <div class="card col-lg-12">
    <div class="row">
      <div class="card-header col-lg-12 header-dashboard-button-2">
        <h3 class="heading-responsive">
          {{ resultSingleResponse.first_name }}
          {{ resultSingleResponse.last_name }} Result
        </h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="card-body p-4">
        <div class="container">
          <div class="row justify-content-center">
            <!-- <div class="col-md-2">
             
              <img
                src="https://via.placeholder.com/100"
                width="100" height="100"
                alt="Logo"
                class="border rounded-0"
              />
            </div> -->
            <div class="col-lg-8 col-md-12 col-sm-12 text-center">
              <h3 class="text-dark font-weight-bold">
                {{ resultSingleResponse.center_name }}
              </h3>
              <!-- <h5 class="text-danger font-weight-normal">
                A MEMBER OF THE LAGOS COVID-19 LABORATORY CONSORTIUM LAGOS STATE
              </h5> -->
              <h3 class="text-info font-weight-bold">
                LABORATORY INVESTIGATION RESULT PAGE
              </h3>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12 text-center">
              <!-- <img src="#" alt="Logo" width="100" height="100" class="border" > -->
              <img
                src="{{ resultSingleResponse.qrcode_filepath }}"
                width="100"
                height="100"
                alt="QR_Code"
                class="border rounded-0"
              />
              <!-- <p class="font-weight-bold">No 63028175</p> -->
            </div>

            <!-- <div class="col-md-12">
              <span class="ml-5">To verify the authenticity of this test result, visit
                <a
                  href="https://covid19.medfit.com.ng/verify-result">https://covid19.medfit.com.ng/verify-result</a></span>
            </div> -->
          </div>

          <div class="row justify-content-center mt-5">
            <div class="col-md-12 text-center">
              <h4 class="font-weight-bold">
                <u>VIROLOGICAL SCREENING TEST FOR COVID-19 OUTBREAK</u>
              </h4>
            </div>
          </div>

          <div class="row mt-4 ml-1">
            <span
              ><strong>Date: </strong
              ><u>
                <!-- 12/02/2021 -->
                {{ resultSingleResponse.booking_date | date: "M/d/y" }}
              </u></span
            >
            <span class="ml-5"
              ><strong>Appointment ID: </strong
              ><u>
                {{ resultSingleResponse.appointment_id }}
              </u></span
            >
          </div>

          <div class="container mt-3 bg-light">
            <div class="row">
              <div class="col-md-12 col-lg-5 col-sm-12">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">NAME: </span>
                    {{ resultSingleResponse.first_name }}
                    {{ resultSingleResponse.middle_name }}
                    {{ resultSingleResponse.last_name }}</span
                  >
                </p>
                <p class="text-dark">
                  <span class="mr-5"
                    ><span class="font-weight-bold">AGE: </span>
                    {{ resultSingleResponse.dob | age }}
                  </span>
                 
                </p>

                <p class="text-dark">
                <span
                ><span class="font-weight-bold">SEX: </span>
                {{ resultSingleResponse.gender }}
              </span>
              </p>


                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">ADDRESS: </span>
                    {{ resultSingleResponse.address_residential }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">PHONE NO: </span>
                    {{ resultSingleResponse.phone }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">PASSPORT NO.: </span>
                    {{ resultSingleResponse.passport_no }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">EMAIL: </span>
                    {{ resultSingleResponse.email }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold"
                      >COUNTRY OF RESIDENCE:
                    </span>
                    {{ resultSingleResponse.country_residence }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">NATIONALITY: </span>
                    {{ resultSingleResponse.nationality }}</span
                  >
                </p>
              </div>
              <div class="col-md-12 col-lg-2 col-sm-12">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SAMPLE COLLECTED: </span>
                    <br />
                    {{
                      resultSingleResponse.sample_collected_date | date: "M/d/y"
                    }}
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">COLLECTED VIA: </span>
                    
                    {{ resultSingleResponse.collected_via }}
                  </span>
                </p>
                <!-- <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SAMPLE ID: </span>
                    <br />
                    {{ resultSingleResponse.sample_id }}
                  </span>
                </p> -->
              </div>
              <div class="col-md-12 col-lg-5 col-sm-12">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold"
                      >SAMPLE(S): <br />
                      SCREENING/REPEAT/FOLLOW
                    </span>
                  </span>
                </p>

                <!-- Table -->
                <table class="table table-bordered table-light specimen-table-font">
                  <tbody>
                    <tr>
                      <th scope="row">{{ resultSingleResponse.sample_id }}</th>
                      <th scope="row">
                        {{ resultSingleResponse.specimen_type }}
                      </th>
                      <th scope="row">
                        <span *ngIf="resultSingleResponse.status == 'NEGATIVE'">
                          -
                        </span>
                        <span *ngIf="resultSingleResponse.status == 'POSITIVE'">
                          X
                        </span>
                      </th>
                    </tr>

                    <!-- <tr>
                      <th scope="row">2.</th>
                      <th scope="row">OROPHARYNGEAL</th>
                      <th scope="row">X</th>
                    </tr>
                    <tr>
                      <th scope="row">3.</th>
                      <th scope="row">SPUTUM</th>
                      <th scope="row">-</th>
                    </tr>
                    <tr>
                      <th scope="row">4.</th>
                      <th scope="row">VENOUS BLOOD</th>
                      <th scope="row">-</th>
                    </tr>
                    <tr>
                      <th scope="row">5.</th>
                      <th scope="row">OTHERS</th>
                      <th scope="row">-</th>
                    </tr> -->
                  </tbody>
                </table>
                <!-- Table End -->

                <p class="mt-4 mb-3 text-dark">
                  <span class="font-weight-bold">DATE OF RESULT: </span>
                  {{ resultSingleResponse.result_date | date: "M/d/y" }}

                  <span class="font-weight-bold ml-3">VALIDITY: </span>
                  {{ resultSingleResponse.validity_date | date: "M/d/y" }}
                </p>

                <!-- Table -->
                <table class="table table-light specimen-table-font">
                  <tbody>
                    <tr>
                      <th scope="row">STATUS</th>
                      <th scope="row">
                        <span
                        *ngIf="resultSingleResponse.status == 'NEGATIVE'"
                        class="active-btn"
                        >{{ resultSingleResponse.status | titlecase }}</span
                      >
                      <span
                        *ngIf="resultSingleResponse.status == 'POSITIVE'"
                        class="inactive-btn"
                        >{{ resultSingleResponse.status | titlecase }}</span
                      >
                      </th>
                    </tr>

                    <!-- <tr>
                      <th scope="row">POSITIVE</th>
                      <th scope="row">X</th>
                    </tr>
                    <tr>
                      <th scope="row">NEGATIVE</th>
                      <th scope="row">-</th>
                    </tr> -->
                  </tbody>
                </table>
                <!-- Table End -->
              </div>
            </div>
          </div>

          <!-- Result -->
          <div class="row mt-5 ml-1">
            <span><span class="font-weight-bold">RESULT: </span></span>
          </div>

          <div class="container">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  <!-- <th scope="col">TEST DONE</th> -->
                  <th scope="col">SAMPLE ID</th>
                  <th scope="col">LAB CODE (SPECIMEN TYPE)</th>
                  <!-- <th scope="col">REFERENCE RANGE</th> -->
                  <!-- <th scope="col">TEST VALUE</th> -->
                  <th scope="col">COMMENT</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <!-- <td>RT-PCR FOR SARS-COV2</td> -->
                  <td>{{ resultSingleResponse.sample_id }}</td>
                  <td>
                    {{ resultSingleResponse.lab_code }} ({{
                      resultSingleResponse.specimen_type
                    }})
                  </td>
                  <!-- <td>LEK3635</td> -->
                  <!-- <td>ABOVE CUTT OFF</td> -->
                  <!-- <td></td> -->
                  <td>{{ resultSingleResponse.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End Result -->

          <!-- Comment -->
          <div class="row mt-5">
            <div class="col-md-12 text-dark">
              <div class="border" style="border-radius: 20%; padding: 2%">
                <p>
                  <span class="font-weight-bold"><u>General Comment</u></span>
                </p>
                <p>
                  <span class="font-weight-bold"
                    >{{ resultSingleResponse.status.toUpperCase() }} FOR COV 2
                    (COVID-19) AS AT:
                  </span>
                  <u>{{ resultSingleResponse.result_date }}</u>
                </p>
              </div>
              <!-- TODO: Uncomment when data is available in the response body-->
              <div>
                <!-- <p><span class="font-weight-bold">Signature: </span></p>
                <p>............................</p> -->

                <p>
                  <span class="font-weight-bold">Name: </span>
                  {{ resultSingleResponse.lab_attendant_name }}
                </p>

                <!-- <p>
                  <span class="font-weight-bold">Designation: </span> Laboratory
                  Manager
                </p> -->
              </div>
            </div>
          </div>
          <!-- Comment  - End -->

          <!-- Contact Info box -->
          <!-- TODO: Uncomment when data is available in the response body -->
          <div class="row mt-5 mb-5">
            <div class="col-md-12 result-footer text-center p-3">
              <div class="">
                <span class="font-weight-bold">Address: </span>
                {{ resultSingleResponse.center_address }}
              </div>
              <!-- <div class="">
                <span class="font-weight-bold">Lagos: </span> 30b, Aba Johnson
                Crecent, Adeniyi Jones, Ikeja, Lagos, Nigeria
              </div> -->
              <!-- <div class="">
                <span class="font-weight-bold">PH: </span> 45, Eleinwo Street,
                GRA Phase 1, Port Harcourt, Rivers, Nigeria
              </div> -->

              <hr />

              <div class="">
                <span class="font-weight-bold">Phone: </span
                >{{ resultSingleResponse.center_phone }}
                <span class="font-weight-bold ml-3">Email: </span
                >{{ resultSingleResponse.center_email }}
                <!-- <span class="font-weight-bold ml-3">Twitter: </span>@MedBuryNG
                <span class="font-weight-bold ml-3">Instagram: </span>@medburyng -->
              </div>
            </div>
          </div>
          <!-- Contact Info box -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
